import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchFieldDirective } from './search-field.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [SearchFieldDirective],
  exports: [SearchFieldDirective],
})
export class SearchFieldModule {}
